<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 login-max-w sm:m-0 m-4">

      <vx-card>
        <div slot="no-body" class="full-page-bg-color bg-wite">

          <div class="vx-row no-gutter justify-center items-stretch">

            <div class="vx-col hidden lg:flex lg:w-1/2 px-4 py-5 color-bg-login min-h-login">
              <!-- Logo: branding fijo arriba (sale del flujo) -->
              <img class="brand-logo-floating" src="@/assets/images/logo/logo-full.svg" alt="Verificamex">
              <!-- Ilustración: único hijo del flex → se centra vertical y horizontalmente -->
              <img class="login-illustration" src="@/assets/images/pages/login.svg" alt="login">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg flex items-center">
              <div class="p-8 login-tabs-container py-login w-full">

                <!-- Logo visible solo en mobile -->
                <img class="block lg:hidden mb-6 max-w-logo mx-auto" src="@/assets/images/logo/logo-full.svg" alt="Verificamex">

                <div class="login-header mb-6">
                  <h2 class="login-title">¡Hola de nuevo!</h2>
                  <p class="login-subtitle">Inicia sesión para continuar con Verificamex.</p>
                </div>

                <form @submit="submitLogin">

                  <!-- Email -->
                  <div class="form-group">
                    <label class="form-label">Correo electrónico</label>
                    <vs-input
                        name="email"
                        icon-no-border
                        icon="icon icon-mail"
                        icon-pack="feather"
                        v-model="email"
                        placeholder="tunombre@empresa.com"
                        class="w-full input-large"/>
                  </div>

                  <!-- Password -->
                  <div class="form-group mt-4">
                    <div class="flex justify-between items-baseline">
                      <label class="form-label">Contraseña</label>
                      <router-link to="/forgot-password" class="forgot-link">¿La olvidaste?</router-link>
                    </div>
                    <div class="password-wrapper">
                      <vs-input
                          :type="type"
                          name="password"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          v-model="password"
                          placeholder="Tu contraseña"
                          class="w-full input-large"/>
                      <button type="button" class="password-toggle" @click="showPassword" :aria-label="type === 'password' ? 'Mostrar contraseña' : 'Ocultar contraseña'">
                        <feather-icon :icon="icon" svgClasses="w-5 h-5" />
                      </button>
                    </div>
                  </div>

                  <!-- Salta el código del doble factor en este navegador; la contraseña se sigue pidiendo. -->
                  <vs-checkbox v-model="checkbox_remember_me" class="remember-me mt-4">Recordar por 30 días</vs-checkbox>

                  <input type="submit" style="position: absolute; left: -9999px"/>

                  <vs-button
                      :disabled="status.loggingIn"
                      ref="loadableButton"
                      id="button-with-loading"
                      class="vs-con-loading__container login-button mt-5 w-full"
                      @click="submitLogin"
                      type="relief"
                      color="primary">Iniciar sesión</vs-button>

                  <p class="register-link mt-4 text-center">
                    ¿No tienes cuenta?
                    <router-link to="/register">Regístrate gratis</router-link>
                  </p>

                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import router from "../../../../router";
import { deviceFingerprint, trustedDevice } from '@/_helpers';

export default{
  data() {
    return {
      icon: 'EyeIcon',
      type: 'password',
      email: "",
      password: "",
      checkbox_remember_me: false
    }
  },
  created() {
    this.logout()
    // Se calcula mientras el usuario escribe; se manda al terminar de iniciar sesión.
    deviceFingerprint.preload()
    // Si este navegador está recordado, se renueva su cookie y la casilla aparece marcada.
    trustedDevice.touch()
    this.checkbox_remember_me = !!trustedDevice.get()
  },
  computed: {
    ...mapState('account', ['status']),
  },
  methods: {

    showPassword() {
      if(this.type === 'password') {
        this.type = 'text'
        this.icon = 'EyeOffIcon'
      } else {
        this.type = 'password'
        this.icon = 'EyeIcon'
      }
    },
    ...mapActions('account', ['login', 'logout']),
    submitLogin(e) {
      if (e) {
        e.preventDefault();
      }
      const {email, password} = this;
      const remember = this.checkbox_remember_me;
      this.$store.dispatch("alert/clear", {});
      if (email && password) {
        this.$vs.loading({
          background: 'primary',
          color: '#fff',
          container: "#button-with-loading",
          scale: 0.45
        });
        this.login({email, password, remember, aclChangeRole: this.$acl.change})
        .then(
          () => {
            this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          },
          error => {
            this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          }
        )
      } else {
        this.$store.dispatch("alert/error", "Ingrese los datos requeridos");
      }
    }

  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_colorsVariables.scss';

.vs-button-primary.vs-button-relief {
  -webkit-box-shadow: none;
  box-shadow: none;
}

/* WHY: era `height: 500px` (fijo), lo que impedía que la columna izquierda
   se estirara al alto de la columna derecha cuando esta crecía. */
.min-h-login {
  min-height: 500px;
}

/* Columna izquierda — control absoluto del posicionamiento.
   WHY: el SVG de la ilustración tiene whitespace interno, así que centrarla
   con flex deja el "centro geométrico del archivo" en el medio, no el
   "centro visual" de lo que ves. Usamos position:absolute con top:50% y
   translateY para colocar exactamente la mitad visual donde queremos. */
.color-bg-login {
  position: relative !important;
}
.brand-logo-floating {
  position: absolute;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 200px;
  width: auto;
  z-index: 1;
}
.login-illustration {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 86%;
  max-width: 560px;
  height: auto;
}

/* ────────────────────────────────────────────────────────────────
   Header del login
   ──────────────────────────────────────────────────────────────── */
.login-header {
  text-align: left;
}
.login-title {
  font-size: 1.85rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 6px;
  line-height: 1.2;
}
.login-subtitle {
  font-size: 0.95rem;
  color: rgba(0, 0, 0, 0.55);
  line-height: 1.5;
  margin: 0;
}

/* ────────────────────────────────────────────────────────────────
   Form groups + labels
   ──────────────────────────────────────────────────────────────── */
.form-group {
  display: block;
}
.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.78);
  margin-bottom: 6px;
  letter-spacing: 0.1px;
}

/* Override de vs-input — altura cómoda sin inflar.
   WHY: NO usamos line-height para centrar el placeholder; vs-input centra
   nativamente con padding interno, y un line-height igual al height descentra
   visualmente el texto real cuando hay valor escrito. */
.input-large {
  ::v-deep .vs-input--input {
    height: 42px;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    font-size: 0.95rem;
    transition: border-color 0.18s ease, box-shadow 0.18s ease;

    &:focus {
      border-color: $primary !important;
      box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.12);
    }
  }
  ::v-deep .vs-input--placeholder {
    font-size: 0.95rem;
    color: rgba(0, 0, 0, 0.38);
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
  }
  ::v-deep .vs-input--icon {
    top: 50% !important;
    left: 12px !important;
    transform: translateY(-50%);
    padding: 0 !important;
    width: 20px;
    height: 20px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  ::v-deep .vs-icon {
    font-size: 1.05rem;
    line-height: 1;
  }
}

/* ────────────────────────────────────────────────────────────────
   Password toggle (ojo) — posicionado dentro del input
   ──────────────────────────────────────────────────────────────── */
.password-wrapper {
  position: relative;
}
.password-toggle {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: rgba(0, 0, 0, 0.45);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: color 0.18s ease;
  z-index: 2;

  &:hover { color: $primary; }
  &:focus { outline: none; color: $primary; }
}

/* ────────────────────────────────────────────────────────────────
   Forgot password link (alineado con label de contraseña)
   ──────────────────────────────────────────────────────────────── */
.forgot-link {
  font-size: 0.82rem;
  color: $primary;
  font-weight: 500;
  text-decoration: none;
  transition: opacity 0.18s ease;

  &:hover { opacity: 0.75; text-decoration: underline; }
}

/* ────────────────────────────────────────────────────────────────
   Botón principal y link de registro
   WHY: altura forzada a 40px (mismo alto que los inputs sería 42, pero
   los botones suelen verse mejor 1-2px más bajos para no competir).
   Padding del .vs-button-text se neutraliza porque vs-button lo infla.
   ──────────────────────────────────────────────────────────────── */
.login-button {
  height: 40px !important;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.2px;
  padding: 0 !important;
  transition: transform 0.15s ease, box-shadow 0.2s ease;

  ::v-deep .vs-button-text {
    padding: 0 18px !important;
    line-height: 1;
  }

  &:hover:not(.disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(115, 103, 240, 0.25);
  }
}

.remember-me {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.7);
}

.register-link {
  font-size: 0.92rem;
  color: rgba(0, 0, 0, 0.55);

  a {
    color: $primary;
    font-weight: 600;
    margin-left: 4px;
    text-decoration: none;

    &:hover { text-decoration: underline; }
  }
}
</style>
